import React, { useState } from 'react'
import { PhoneNumberUtil } from 'google-libphonenumber'
import GgGolfHubPopup from '../shared/gg_golf_hub_popup'
import { GGInput } from '../../../shared/new_components/GGInput'
import { GGChipGroup } from '../../../shared/new_components/GGChipGroup'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { addMember, hideMemberFormPopup, editMember } from '../../actions/dashboard/members_index'
import GGPhoneInput from 'Shared/new_components/GGPhoneInput'

const phoneUtil = PhoneNumberUtil.getInstance()
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const MemberFormPopup = ({ active, title }) => {
  const dispatch = useDispatch()
  const memberFormAction = useSelector(state => state.memberFormAction)
  const selectedMember = useSelector(state => state.editMember)
  const customerCountry = useSelector(state => state.customerCountry)

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [firstName, setFirstName] = useState(selectedMember['firstName'] || '')
  const [lastName, setLastName] = useState(selectedMember['lastName'] || '')
  const [teamId, setTeamId] = useState(selectedMember['teamId'] || '')
  const [gender, setGender] = useState(selectedMember['gender'] || '')
  const [email, setEmail] = useState(selectedMember['email'] || '')
  const [handicapId, setHandicapId] = useState(selectedMember['handicapId'] || '')
  const [phone, setPhone] = useState(selectedMember['phone'] || '')

  const handleOnConfirm = () => {
    if (isSubmitting) { return }
    setIsSubmitting(true)
    const memberParams = { firstName, lastName, email, handicapId, gender, phone, teamId }
    const genderHash = {
      Male: 'M',
      Female: 'F',
      unknown: 'unknown',
    }
    memberParams['gender'] = genderHash[memberParams['gender']]
    const request = memberFormAction === 'new'
      ? dispatch(addMember(memberParams))
      : dispatch(editMember(memberParams))
    request.finally(() => setIsSubmitting(false))
  }
  const handleOnClose = () => {
    dispatch(hideMemberFormPopup())
  }
  const isPhoneValid = (phone) => {
    try {
      phoneUtil.isPossibleNumber(phoneUtil.parseAndKeepRawInput(phone))
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))
      } catch (error) {
        return false
      }
    } catch (error) {
      return true
    }
  }
  const isEmailValid = (email) => email === '' || EMAIL_REGEX.test(email)
  const isConfirmDisabled = isSubmitting || lastName === '' || !isPhoneValid(phone) || !isEmailValid(email)

  const handleOnKeyDown = (event) => {
    if (event.key !== 'Enter') { return }
    const { tagName, type } = event.target
    if (tagName !== 'INPUT' || [ 'radio', 'checkbox' ].includes(type)) { return }
    if (event.target.closest('.phone-custom-dropdown')) { return }

    event.preventDefault()
    if (isConfirmDisabled) { return }
    handleOnConfirm()
  }

  return (
    <GgGolfHubPopup
      isOpen={active}
      title={title}
      onClose={handleOnClose}
      onConfirm={handleOnConfirm}
      isConfirmDisabled={isConfirmDisabled}
      confirmText={window.I18n.t('buttons.save')}
      >
      <div onKeyDown={handleOnKeyDown}>
        <div className='add-margin-bottom-15'>
          <GGInput name='member-first-name' label={window.I18n.t('gg_golf_hub.member_form_popup.first_name')} value={firstName} onChange={setFirstName}/>
        </div>
        <div className='add-margin-bottom-15'>
          <GGInput name='member-last-name' label={window.I18n.t('gg_golf_hub.member_form_popup.last_name')} value={lastName} onChange={setLastName} />
        </div>
        <div className='add-margin-bottom-15'>
          <GGInput name='member-team-id' label={window.I18n.t('gg_golf_hub.member_form_popup.team_id')} value={teamId} onChange={setTeamId} />
        </div>
        <div className='add-margin-bottom-15'>
          <p className='text-ds-form-label'>
            {window.I18n.t('gg_golf_hub.member_form_popup.gender')}
          </p>
          <GGChipGroup
            name='member-gender'
            options={[
              { label: window.I18n.t('gg_golf_hub.member_form_popup.gender_male'), value: 'Male' },
              { label: window.I18n.t('gg_golf_hub.member_form_popup.gender_female'), value: 'Female' },
              { label: window.I18n.t('gg_golf_hub.member_form_popup.gender_unknown'), value: 'unknown' },
            ]}
            value={gender}
            onChange={setGender}
          />
        </div>
        <div className='add-margin-bottom-15'>
          <GGInput name='member-email' label={window.I18n.t('gg_golf_hub.member_form_popup.email_address')} type='email' value={email} onChange={setEmail} />
        </div>
        <div className='add-margin-bottom-15'>
          <GGPhoneInput
            value={phone}
            onChange={setPhone}
            defaultCountry={customerCountry.toLowerCase()}
            label={window.I18n.t('gg_golf_hub.member_form_popup.phone_number')} />
        </div>
        <GGInput name='member-handicap-id' label={window.I18n.t('gg_golf_hub.member_form_popup.handicap_id')} value={handicapId} onChange={setHandicapId} />
      </div>
    </GgGolfHubPopup>
  )
}

MemberFormPopup.propTypes = {
  active: PropTypes.bool,
  title: PropTypes.string,
}

export default MemberFormPopup
